import {ICollectionItemResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/ICollectionItemResponseInstance'
import {CollectionItemType} from '@toolify/server/src/models/mongoose/CollectionItemModel/enum/CollectionItemType'
import {
  IResourceCollectionItemPayload,
} from '@toolify/server/src/services/CollectionService/strategies/ResourceCollectionItemTypeStrategy/types/IResourceCollectionItemTypeStrategyInterfaces'

export function getCollectionResourcePayload(item: ICollectionItemResponseInstance): IResourceCollectionItemPayload | null {
  if(item.collectionItemType !== CollectionItemType.Resource) {
    return null
  }
  return item.collectionItemTypePayload as IResourceCollectionItemPayload
}
